import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Leaf } from 'lucide-react';
import { ServiceAreaMap } from './ServiceAreaMap';
export function ServiceAreasSection() {
  const tennesseeAreas = ['Chattanooga', 'Hixson', 'Soddy Daisy', 'Dayton', 'Ooltewah', 'Jasper', 'Athens', 'Cleveland'];
  const georgiaAreas = ['Rossville', 'Fort Oglethorpe', 'Dalton'];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -10
    },
    visible: {
      opacity: 1,
      x: 0
    }
  };
  return <section className="py-20 bg-brand-black relative overflow-hidden" data-id="element-199">
      {/* Decorative corner leaves */}
      <Leaf className="absolute top-10 left-10 text-brand-gold opacity-10 w-24 h-24 -rotate-12" data-id="element-200" />
      <Leaf className="absolute bottom-10 right-10 text-brand-gold opacity-10 w-32 h-32 rotate-45" data-id="element-201" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-202">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-203">
          <div className="inline-flex items-center justify-center p-3 bg-brand-gold/10 rounded-full mb-4 text-brand-gold" data-id="element-204">
            <MapPin size={32} data-id="element-205" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-206">
            Proudly Serving Your Community
          </h2>
          <p className="text-xl text-brand-gold font-medium" data-id="element-207">
            We're your neighbors — and we take care of our neighbors.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-16 max-w-4xl mx-auto bg-brand-dark rounded-2xl shadow-sm p-8 md:p-12 border border-brand-gold/10 relative" data-id="element-208">
          {/* Map pin dotted trail decoration */}
          <div className="absolute left-1/2 top-12 bottom-12 w-px border-l-2 border-dashed border-brand-gold/20 hidden md:block" data-id="element-209"></div>

          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} data-id="element-210">
            <h3 className="text-2xl font-serif font-bold text-white mb-6 border-b border-brand-gold/20 pb-4 flex items-center gap-2" data-id="element-211">
              <span className="w-2 h-6 bg-brand-gold rounded-full" data-id="element-212"></span>
              Tennessee
            </h3>
            <ul className="space-y-3" data-id="element-213">
              {tennesseeAreas.map((area, index) => <motion.li key={index} variants={itemVariants} className="flex items-center gap-3 text-lg text-gray-300" data-id="element-214">
                  <div className="w-1.5 h-1.5 rounded-full bg-brand-gold" data-id="element-215"></div>
                  {area}
                </motion.li>)}
            </ul>
          </motion.div>

          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} data-id="element-216">
            <h3 className="text-2xl font-serif font-bold text-white mb-6 border-b border-brand-gold/20 pb-4 flex items-center gap-2" data-id="element-217">
              <span className="w-2 h-6 bg-brand-gold rounded-full" data-id="element-218"></span>
              Georgia
            </h3>
            <ul className="space-y-3" data-id="element-219">
              {georgiaAreas.map((area, index) => <motion.li key={index} variants={itemVariants} className="flex items-center gap-3 text-lg text-gray-300" data-id="element-220">
                  <div className="w-1.5 h-1.5 rounded-full bg-brand-gold" data-id="element-221"></div>
                  {area}
                </motion.li>)}
            </ul>
          </motion.div>
        </div>

        {/* Interactive Map */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="mt-12 max-w-4xl mx-auto" data-id="element-222">
          <ServiceAreaMap data-id="element-223" />
        </motion.div>
      </div>
    </section>;
}